import React from "react";
import { Provider } from "react-redux";
import store from "App/store/store";
import AppNavigator from "App/common/AppNavigator";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import Socket from "App/common/Socket";
import GlobalSIPProvider from "App/common/GlobalSIPProvider";
import CallModal from "App/screens/bookingnew/components/callComponent/CallModal";

const App: React.FC = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#CC0000",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            // Your button styles here if needed
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            // Your text field styles here if needed
          },
        },
      },
    },
  });

  return (
    <div className="app">
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Socket />
          <GlobalSIPProvider />
          <CallModal />
          <AppNavigator />
        </ThemeProvider>
      </Provider>
    </div>
  );
};

export default App;
